{
  "service-selection-dialog": {
    "buttons": {
      "save": "Speichern"
    },
    "text": {
      "service-selection": "Auswahl der Dienstleistungen"
    }
  },
  "service-selection-form": {
    "buttons": {
      "add-more": "Mehr Service hinzufügen"
    },
    "text": {
      "duration": "Dauer",
      "hint": "Bitte wählen Sie mindestens eine Dienstleistung aus",
      "total": "Gesamtbetrag"
    }
  }
}
